export enum TARGET {
	PLUGIN = 'plugin'
}
